import { render } from "./App.vue?vue&type=template&id=3e238fee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3e238fee&lang=css"

import exportComponent from "/home/louispasquier/Data/Dev/Web/trainingplanmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__